import { render, staticRenderFns } from "./MedicalPrescriptionIcon.vue?vue&type=template&id=645ed52c&scoped=true&"
import script from "./MedicalPrescriptionIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MedicalPrescriptionIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645ed52c",
  null
  
)

export default component.exports